import { State } from "../types";

export interface CloseSidebarAction {
  type: "CLOSE SIDEBAR";
}
export interface ToggleSidebarAction {
  type: "TOGGLE SIDEBAR";
}

export const closeSidebar = (state: State, _: CloseSidebarAction): State => {
  if (state.sidebarVisible === false) {
    return state;
  }
  return { ...state, sidebarVisible: false };
};

export const toggleSidebar = (state: State, _: ToggleSidebarAction): State => {
  return { ...state, sidebarVisible: !state.sidebarVisible };
};
